/* Hook encargado de hacer la consulta a la base y 
traer la liquidación (settlement)

Autor: Benjamín León
Fecha: 2024-11-09
*/
import { useState } from 'react'

import { fechaIsoToYYYY_MM_DD } from '../utils/utils.ts'
import { customFetch } from '../utils/customFetch.ts'
import Settlement from '../interfaces/Settlement.ts'

import { makeUrlSettlement } from './connectionData.tsx'

const useSettlementFetcher = () => {
  const [errorSettlement, setErrorSettlement] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchSettlement = async (id: string) => {
    setLoading(true)

    try {
      const data = await fetchDatabase(id)
      setErrorSettlement(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorSettlement(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }
  const fetchDatabase = async (id: string): Promise<Settlement> => {
    const apiUrl = makeUrlSettlement(id)

    // Fetching documents from the collection and converting them into an array
    const settlement = await customFetch<Settlement>(apiUrl)

    if (Array.isArray(settlement.notes)) {
      const notes = (settlement.notes ?? []).join('\n')
      settlement.notes = notes
    }
    settlement.date = fechaIsoToYYYY_MM_DD(settlement.date)

    //reservation.date = formatDateToYYYY_MM_DD(new Date(reservation.date))
    return settlement
  }

  // Exponemos estas variables al exterior
  return { errorSettlement, loading, fetchSettlement }
}
export default useSettlementFetcher
